<template>
  <div v-if="title">
    <b-input-group size="sm">
      <template v-slot:prepend>
        <b-input-group-text>
          <span class="d-inline d-md-none">{{ title['0'] }}</span><span class="d-none d-md-inline">{{ title[1] }}</span>
        </b-input-group-text>
      </template>
      <b-form-select v-if="register.options.length > 0" :options="register.options" v-model="register.current"
                     @change="Select"></b-form-select>
      <b-form-input readonly v-else size="sm" value="Справочник организаций не заполнен"></b-form-input>
    </b-input-group>
  </div>

  <div v-else>
    <b-form-select size="sm" v-if="register.options.length > 0" :options="register.options" v-model="register.current"
                   @change="Select"></b-form-select>
    <b-form-input readonly v-else size="sm" value="Справочник организаций не заполнен"></b-form-input>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'SelectOrg',
  props: ['title'],

  methods: {
    Select: function () {
      if (this.org) {
        this.$http
            .post(this.$apiold, {
              task: 'list',
              mode: 'select',
              id: this.register.current,
              orgid: this.orgs.current.id,
              params: {name: 'orgs', table: 'reg_organizations', org: false, order: ' ORDER BY name ASC'},
              changed: true
            })
            .then(response => {
              this.$store.commit('regChange', {name: 'orgs', register: response.data.register});
            });
      } else {
        this.$http
            .post(this.$apiold, {
              task: 'list',
              mode: 'select',
              id: this.register.current,
              params: {name: 'orgs', table: 'reg_organizations'},
              changed: true
            })
            .then(response => {
              this.$store.commit('regChange', {name: 'orgs', register: response.data.register});
            });
      }

    }
  },
  computed: {
    ...mapGetters({
      orgs: 'orgs'
    }),
    register: {
      get() {
        return this.$store.getters.regSelect('orgs', ['name'], true);
      }
    }
  }
}
</script>
